<template>
  <Layout id="app">
    <SearchBar/>
    <p-header/>
    <router-view/>
    <p-footer></p-footer>
    <BackTop style="z-index: 1000"></BackTop>
  </Layout>
</template>

<script>
import SearchBar from './components/SearchBar.vue';
import PHeader from './components/Header.vue';
import PFooter from './components/Footer.vue';

export default {
  name: 'app',
  components: {
    SearchBar,
    PHeader,
    PFooter,
  },
};
</script>

<style lang="scss">
#app {
  background: whitesmoke;
  margin: auto;
  // box-shadow: 0px 0px 5px 0px #c5c8ce;
}
body {
  background-color: whitesmoke !important;
}
.layout-nav {
  // width: 607px;
  li:last-child {
    padding-right: 0px;
  }
  li:first-child {
    padding-left: 0px;
  }
}
.pro-content.ivu-layout-content {
  width: 100%;
  margin: auto;
  // background: #F3F7F0;
  // padding: 0 50px;
}
.pro-content {
  .wrapper {
    margin-top: 30px;
    margin-bottom: 30px;
    div {
      &:child(2) {
        margin-top: 5px;
        border-radius: 4px;
        background-color: whitesmoke;
      }
    }
    .type-card {
      .ivu-card-body {
        background-color: whitesmoke;
      }
    }
  }
}
@media only screen and (max-width: 1250px) {
  #app {
    > * {
      padding: 0 15px;
    }
  }
}
@media only screen and (min-width: 1250px) {
  #app {
    > * {
      padding: 0 15px;
    }
  }
}
.icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spin-col {
  height: 300px;
  position: relative;
  border: 1px solid #eee;
}
</style>
